export enum ClientRouteSegmentEnum {
	Client = 'client',
	NewRequest = 'new-request',
	RequestsStatuses = 'request-statuses',
	Notifications = 'notifications',
	Accounting = 'accounting',
	Settings = 'settings',
	FrequentlyAskedQuestions = 'faq',
	Autopark = 'autopark',
	Fuel = 'fuel',
	LeasingContracts = 'leasing-contracts',
	AboutCreditHistory = 'about-credit-history',
	Mail = 'mail'
}
